export default "__VITE_ASSET__PF14oH7Q__"